export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '',
  uc_host: 'http://user.sxltw.cn',
  site_host: 'http://www.sxltw.cn',
  special_url: '/',
  site_title: '陕西猎头网 - 软文营销',
  welcome_title: '陕西猎头网 — 软文营销',
  site_short_title: '陕西猎头网 - 软文营销',
  site_subtitle: '陕西猎头网 - 软文营销',
  company_name: '陕西猎头人力资源有限公司',
  copyright: '© 2024 陕西猎头人力资源有限公司',
  logo: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/240403/7847b745e27d4f67ec35d72407805a86.png',
  favicon: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/240403/4db87a4c81af9e81c031fd6b9c211e38.png',
  payment: '',
  qq: '353776027',
  tel: '029-86256805',
  company_account_id: '7251 2101 8220 0112 011',
  company_bank: '中信银行股份有限公司西安经济技术开发区支行',
  company_bank_name: '陕西猎头人力资源有限公司',
  alipay_account_id: 'Zhangli2005011@163.com',
  alipay_name: '张振刚',
  alipay_pic: '',
  section_id: 5334116,
  belonger_id: 5334116,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 